import {
    createAsyncThunk,
    createSlice,
} from "@reduxjs/toolkit";

import {
    employeeAdvanceApi,
    employeeSalaryApi,
} from "../../components/dashboard/components/AdminComponent/EmployeeManagement/utils/employeeApi";


const initialState = {

    records:
        [],

    selected:
        null,

    payments:
        [],

    summary: {

        totalEmployees:
            0,

        grossSalary:
            0,

        totalDeduction:
            0,

        netSalary:
            0,

        paidAmount:
            0,

        balanceAmount:
            0,

    },

    pagination: {

        page:
            1,

        limit:
            10,

        totalRecords:
            0,

        totalPages:
            1,

    },

    loading:
        false,

    actionLoading:
        false,

    error:
        null,

};


/*
|--------------------------------------------------------------------------
| LIST
|--------------------------------------------------------------------------
*/

export const fetchEmployeeSalaries =
    createAsyncThunk(
        "employeeSalary/list",

        async (
            payload,
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeSalaryApi
                        .getList(
                            payload
                        );


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to load salaries."
                    );

                }


                return {

                    records:
                        response?.data ||
                        [],

                    pagination:
                        response?.pagination ||
                        {},

                };

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to load salaries."
                );

            }

        }
    );


/*
|--------------------------------------------------------------------------
| GENERATE
|--------------------------------------------------------------------------
*/

export const generateEmployeeSalary =
    createAsyncThunk(
        "employeeSalary/generate",

        async (
            payload,
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeSalaryApi
                        .generate(
                            payload
                        );


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to generate salary."
                    );

                }


                return response
                    ?.data;

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to generate salary."
                );

            }

        }
    );


/*
|--------------------------------------------------------------------------
| SUMMARY
|--------------------------------------------------------------------------
*/

export const fetchEmployeeSalarySummary =
    createAsyncThunk(
        "employeeSalary/summary",

        async (
            params,
            {
                rejectWithValue,
            }
        ) => {

            try {

                const response =
                    await employeeSalaryApi
                        .getSummary(
                            params
                        );


                if (
                    response?.status !==
                    "success"
                ) {

                    return rejectWithValue(
                        response?.message ||
                        "Unable to load salary summary."
                    );

                }


                return response
                    ?.data ||
                    {};

            } catch (
                error
            ) {

                return rejectWithValue(
                    error?.response?.data?.message ||
                    error?.message ||
                    "Unable to load salary summary."
                );

            }

        }
    );


const employeeSalarySlice =
    createSlice({

        name:
            "employeeSalary",

        initialState,

        reducers: {

            clearSalaryError:
                (
                    state
                ) => {

                    state.error =
                        null;

                },

            clearSelectedSalary:
                (
                    state
                ) => {

                    state.selected =
                        null;

                    state.payments =
                        [];

                },

        },

        extraReducers:
            (
                builder
            ) => {

                builder

                    .addCase(
                        fetchEmployeeSalaries
                            .pending,
                        (
                            state
                        ) => {

                            state.loading =
                                true;

                            state.error =
                                null;

                        }
                    )

                    .addCase(
                        fetchEmployeeSalaries
                            .fulfilled,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.records =
                                action
                                    .payload
                                    ?.records ||
                                [];

                            state.pagination = {

                                ...state.pagination,

                                ...(
                                    action
                                        .payload
                                        ?.pagination ||
                                    {}
                                ),

                            };

                        }
                    )

                    .addCase(
                        fetchEmployeeSalaries
                            .rejected,
                        (
                            state,
                            action
                        ) => {

                            state.loading =
                                false;

                            state.error =
                                action.payload;

                        }
                    );


                builder

                    .addCase(
                        fetchEmployeeSalarySummary
                            .fulfilled,
                        (
                            state,
                            action
                        ) => {

                            state.summary = {

                                ...state.summary,

                                ...(
                                    action.payload ||
                                    {}
                                ),

                            };

                        }
                    );


                builder

                    .addCase(
                        generateEmployeeSalary
                            .pending,
                        (
                            state
                        ) => {

                            state.actionLoading =
                                true;

                            state.error =
                                null;

                        }
                    )

                    .addCase(
                        generateEmployeeSalary
                            .fulfilled,
                        (
                            state
                        ) => {

                            state.actionLoading =
                                false;

                        }
                    )

                    .addCase(
                        generateEmployeeSalary
                            .rejected,
                        (
                            state,
                            action
                        ) => {

                            state.actionLoading =
                                false;

                            state.error =
                                action.payload;

                        }
                    );

            },

    });


export const {
    clearSalaryError,
    clearSelectedSalary,
} =
    employeeSalarySlice.actions;


export default employeeSalarySlice.reducer; 